import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Badge,
  createStyles,
  withStyles,
  useIsMobile
} from '@paintscout/ui'
import type { MuiTheme as Theme, WithStyles } from '@paintscout/ui'
import React from 'react'
import classNames from 'classnames'
import Feature from '../Feature'
import type { QuoteSidebarPage } from './QuoteSidebar'
import BaseSidebarPage from './BaseSidebarPage'

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      color: theme.palette.text.primary,
      paddingTop: 0
    },
    listItem: {
      paddingLeft: 0,
      paddingRight: 0,
      cursor: 'pointer'
    },
    badge: {
      top: 4
    }
  })
}

export interface QuoteSidebarIndexProps extends WithStyles<typeof styles> {
  onClick: (name: string, ev: React.MouseEvent) => void
  pages: QuoteSidebarPage[]
}

function QuoteSidebarIndex({ classes, pages, onClick }: QuoteSidebarIndexProps) {
  const mobile = useIsMobile()
  return (
    <BaseSidebarPage className={classNames(classes.root, 'tour-quote-sidebar-index')}>
      <List className={classes.root}>
        {pages.map((item, index) => {
          if (index === 0) {
            return null
          }
          return (
            <Feature key={item.key} required={item.features}>
              <ListItem onClick={(ev) => onClick(item.key, ev)} classes={{ root: classes.listItem }}>
                {item.icon && (
                  <ListItemAvatar>
                    <Badge badgeContent={item.badgeContent} color="primary" classes={{ badge: classes.badge }}>
                      <Avatar>{item.icon}</Avatar>
                    </Badge>
                  </ListItemAvatar>
                )}
                <ListItemText
                  primary={item.title}
                  secondary={item.subtitle}
                  primaryTypographyProps={{ variant: 'body1' }}
                  secondaryTypographyProps={{ variant: mobile ? 'body1' : 'subtitle2' }}
                />
              </ListItem>
            </Feature>
          )
        })}
      </List>
    </BaseSidebarPage>
  )
}

export default withStyles(styles)(QuoteSidebarIndex)
